import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import {CSSTransition} from 'react-transition-group';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentStartPrivate = (props) => {
  const [mount, setMount] = useState(false);
  const [render, setRender] = useState(true);

  let externalSystemReferenceRegex = /externalSystemReference=([^&]+)/;
  let banRegex = /ban=([^&]+)/;
  let amountRegex = /amount=([^&]+)/;

  useEffect(() => {
    if (props.currentStep === stepEnum.START) {
      setRender(true);
      setMount(true);
      const param = props.selectedFromPortal ? 'portal' : 'lobby';
      gaEvent(gaParams.PRIVATEDEBT_ENTER_PAGE.category, gaParams.PRIVATEDEBT_ENTER_PAGE.eventType, param);

      //bit event

      let location = window.location.search;
      let query = new URLSearchParams(location);
      let externalSystemReference, selectedBan, selectedAmount;
      let bitEvent = false;
      const paymentData = query.get('paymentData');
      if (paymentData) {
        bitEvent = true;
        let decodedString = atob(paymentData);

        externalSystemReference = decodedString.match(externalSystemReferenceRegex)[1];
        selectedBan = decodedString.match(banRegex)[1];
        selectedAmount = decodedString.match(amountRegex)[1];
      }

      props.onclick({
        bitEvent,
        selectedAmount,
        selectedBan,
        externalSystemReference,
      });
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return <>{mount && <Container fluid className={'debtpayment-step'}></Container>}</>;
};

export default DebtPaymentStartPrivate;
